import React from 'react';
import SplashView from '../SplashView';
import LoaderIcon from '../../graphics/Loader';
const Loader = ({ type = 'brand', hideLogo = true, styles }) => {
    return (React.createElement(SplashView, { hideLogo: hideLogo, type: type },
        React.createElement(LoaderIcon, { styles: styles })));
};
export default Loader;
//# sourceMappingURL=index.js.map